export const environment = {
    api: "https://insightapi.zalkit.com"
};
